import { h, Fragment } from "preact";
import { Trans } from "@lingui/react/macro";
import { BETS_SEARCH_STATUSES } from "../../../awrabet/utils/ticket-statuses";
import { Cell, CustomTable, EmptyRecordsMessage, FiltersRow, HCell, HRow, Pagination, Panel, PanelRow, Row } from "../../../awrabet/utils/table-utils";
import { DateHelperFilter, PerPageFilter } from "../../../awrabet/utils/form-utils";
import TicketLogic from "../../../awrabet/utils/ticket-logic";
import MoneyFormatter from "../../../awrabet/utils/money-formatter";
import OddsFormatter from "../../../awrabet/utils/odds-formatter";

import * as U from "../../../awrabet/desktop-templates/menu-user";
import * as I from "../../../awrabet/utils/icons";

import { useHeadlessComponent } from "../../../../utils/component-converter";
import AwrabetBetsHistoryPage from "../../../awrabet/desktop-components/user/menu-bets-history";
import {
    BetsTable as JamibetBetsTable,
    BetsTableRow as JamibetBetsTableRow,
} from "../../../jamibet/desktop-components/user/menu-bets-history";

import { RichiamaPrenotataApi } from "../../../../services/ticket";

function canReBet(row) {
    if (row.statusCode !== 'P' || row.live) return false;
    const dettaglio = row.dettaglio;
    if (!dettaglio) return false;
    const now = new Date();
    return Object.values(dettaglio).some(item =>
        !item.event
        && !item.status
        && !item.risultato
        && new Date(item.data_evento) > now
    );
}

function handleReBet(row) {
    RichiamaPrenotataApi.rebetBet(
        row.code,
        row.dettaglio,
        row.importo_scommesso,
        (err) => {
            if (err && err !== "no-eligible-events") {
                alert(err);
            }
        }
    );
}

class BetsTableRow extends JamibetBetsTableRow {
    render({ row, onIdClick = null }) {
        const showRebet = canReBet(row);
        return <Fragment>
            <Row class="betstable-main-row align-middle">
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="betstable-print-button"
                        onClick={e => !!onIdClick && onIdClick({ id: row.code, code: row.code.toUpperCase() })}
                    >
                        {row.code.toUpperCase()}
                        <i class="fa fa-print main-color ml-3" />
                    </a>
                    <span class="block text-xs leading-3 pb-1">
                        {this.printDateFormat(row.time)}
                    </span>
                </Cell>
                <Cell>{row.username}</Cell>
                <Cell>{row.type}</Cell>
                <Cell>
                    {!!row.cashout && this.renderCashoutButton(row)}
                    {showRebet && !row.cashout &&
                        <a
                            href="javascript:void(0)"
                            class="betstable-rebet-button button-minimal text-xs font-bold rounded leading-5"
                            onClick={e => handleReBet(row)}
                        >
                            <Trans>Re-bet <i class="fa fa-refresh inline-block ml-1" /></Trans>
                        </a>}
                </Cell>
                <Cell><MoneyFormatter value={row.importo_scommesso} currency={row.currency} /></Cell>
                <Cell>
                    {row.eventi}
                    {!!row.presi ? <span> / <span class="text-green-600 font-bold">{row.presi}</span></span> : ''}
                </Cell>
                <Cell class="main-color font-bold"><OddsFormatter odds={row.tot_odd} /></Cell>
                <Cell>
                    <span class="flex flex-row items-center justify-center">
                        <span class="w-full text-xs font-bold text-left">{row.status}</span>
                        {this.statusIcon(row)}
                    </span>
                </Cell>
                <Cell><MoneyFormatter value={row.vincita} currency={row.currency} /></Cell>
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="block px-2"
                        onClick={e => this.setState({ showdetails: !this.state.showdetails })}
                    >
                        <i class={"fa " + (!this.state.showdetails ? 'fa-chevron-down' : 'fa-chevron-up')} />
                    </a>
                </Cell>
            </Row>
            {!!this.state.showdetails && <Row>
                <Cell colspan="10">
                    <CustomTable class="w-full border-b-4 text-xs font-sans border-(--main-color)">
                        <tbody>
                            {!!row.live ? this.renderLiveDetails(row.dettaglio) : this.renderPrematchDetails(row.dettaglio)}
                        </tbody>
                    </CustomTable>
                </Cell>
            </Row>}
            <Row>
                <Cell colspan="10" class="border-0 p-0">
                    <div class="block w-full py-px" />
                </Cell>
            </Row>
        </Fragment>;
    }
}

class BetsTable extends JamibetBetsTable {
    render({ data, onIdClick = null }) {
        return <Panel>
            <PanelRow>
                {!this.state.data.length ?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        <CustomTable style="font-family:'Arial rounded', Arial, sans-serif;" class="w-full table-auto border border-l-0 border-b-0 main-text-color">
                            <thead class="text-center font-bold bg-gray-200 body-bg-color">
                                <HRow>
                                    <HCell><Trans>ID e Data</Trans></HCell>
                                    <HCell><Trans>Username</Trans></HCell>
                                    <HCell><Trans>Tipo Scommessa</Trans></HCell>
                                    <HCell><Trans>Cashout</Trans></HCell>
                                    <HCell><Trans>Puntata</Trans></HCell>
                                    <HCell><Trans>N. Eventi</Trans></HCell>
                                    <HCell><Trans>Quota Totale</Trans></HCell>
                                    <HCell><Trans>Stato</Trans></HCell>
                                    <HCell><Trans>Vincita</Trans></HCell>
                                    <HCell />
                                </HRow>
                            </thead>
                            <tbody class="text-center">
                                {this.state.data.map(bet => <BetsTableRow row={bet} onIdClick={onIdClick} />)}
                            </tbody>
                        </CustomTable>
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => { this.state.onNavigation(page, page * this.state.recordperpage - this.state.recordperpage) }}
                            isLastPage={this.state.totalpages === this.state.page}
                        />}
                    </Fragment>}
            </PanelRow>
        </Panel>;
    }
}

export default function BetsHistoryPage(props) {
    const api = useHeadlessComponent(AwrabetBetsHistoryPage, {
        ...props,
        defaultHelperValue: 3
    });
    const { state } = api;

    return <div>
        <div class="overflow-x-auto user-menu-subnav">
            <U.SubTabsContainer>
                {Object.entries(state.statustypes).map(
                    ([key, item]) => <U.Tab selected={key === state.statusfilter} onClick={e => api.changeFilter(key)} >{item.label}</U.Tab>
                )}
            </U.SubTabsContainer>
        </div>
        <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{state.statustypes[state.statusfilter].description}</div>
        <FiltersRow class="gap-2 flex flex-col sm:flex-row p-2 text-sm sm:items-end justify-center items-stretch">
            <DateHelperFilter
                {...state.dateFilter}
                onInput={
                    (dateFilter) => {
                        api.state.dateFilter = dateFilter;
                        api.setState(api.state);
                    }
                }
            />
            <PerPageFilter
                perPage={state.perPage}
                pageList={[15, 30, 45, 50, 100]}
                onInput={
                    ({ perPage }) => {
                        api.state.perPage = perPage;
                        api.setState(api.state);
                    }
                }
            />
            <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => api.performSearch()}>
                <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
            </a>
        </FiltersRow>
        <div class="text-sm mt-3">
            <BetsTable
                {...state.response}
                onIdClick={ticket => TicketLogic.printTicket(ticket)}
                onNavigation={api.changePage}
            />
        </div>
    </div>;
}
